import React, { FC } from 'react'

export const Page404: FC = () => {
    return (
        <div className="Page404">
            Page Not Found
        </div>
    )
}